import { createAction } from "../actions";
import { SET_COLOR_MODE } from "./consts";
export const toggleTheme = () => createAction(SET_COLOR_MODE);
